import React from "react";
import ModalSkeleton from "../../components/ModalSkeleton";
import { AreYouSureIcon } from "../../constant";
import classes from "./AreYouSureWantToCompletedModal.module.css";
import ModalAction from "../../components/ModalAction";
import { GiConfirmed } from "react-icons/gi";
const AreYouSureWantToCompleteModal = ({
  show,
  setShow,
  title = "Booking",
  description,
  onConfirm,
  data,
  loading,
}) => {
  console.log("data ==> are you sure modal", data);
  return (
    <ModalSkeleton show={show} setShow={setShow} width="498px">
      <div className={classes.wrapper}>
        <div>
        
        <GiConfirmed color="var(--green-color)"  size={77}/>
          {/* <AreYouSureIcon /> */}
        </div>
        <div>
          <h3 className={classes.title}>Are Your Sure?</h3>
          <p className={classes.description}>
            Do you really want to mark {title}{" "}
            <span className={classes.shine}>{data}</span> as completed? Once
            conmpleted, this action cannot be undone.
          </p>
        </div>
        <ModalAction
          onCancel={() => setShow(false)}
          onConfirm={onConfirm}
          confirmText="Confirm"
          cancelText="Cancel"
          loading={loading}
        />
      </div>
    </ModalSkeleton>
  );
};

export default AreYouSureWantToCompleteModal;
